import { MeetingRoom } from "../../meeting-room";
import { Create } from "../../meeting-room/pages/create";

export const meetingRoomRoutes = {
  meetingRoomPage: {
    isAdmin: false,
    title: "7. Đăng ký và sử dụng phòng họp",
    path: "/procedure/meeting-room",
    parentId: "procedure",
    component: MeetingRoom,
  },
  meetingRoomCreatePage: {
    isAdmin: false,
    title: "4. Đơn xin nghỉ phép",
    path: "/procedure/meeting-room/create/:id",
    parentId: "procedure",
    component: Create,
  },
  // courseStaffDetailPage:{
  //   isAdmin: false,
  //   title: "4. Đơn xin nghỉ phép",
  //   path: "/procedure/course-person-change-form/details/:id",
  //   parentId: "procedure",
  //   component:Detail,
  // }
};
